import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const Portfolio = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch("https://admin.socioloom.com/api/portfolio.php") // adjust path
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setProjects(data.data);
        }
      })
      .catch((err) => console.error("API Error:", err));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 px-6 md:px-12 py-16">
      {/* Header */}
      <motion.div
        className="text-center mb-16"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h1 className="text-4xl md:text-6xl font-extrabold mb-4">
          Our <span className="text-indigo-600">Portfolio</span>
        </h1>
        <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
          A showcase of innovative solutions and projects built by{" "}
          <span className="font-semibold text-indigo-600">SocioLoom</span>.
        </p>
      </motion.div>

      {/* Project Cards */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
        {projects.map((proj, i) => (
          <motion.div
            key={proj.id}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.2, duration: 0.7 }}
            viewport={{ once: true }}
            className="bg-white rounded-2xl shadow-lg overflow-hidden group relative hover:shadow-2xl transition duration-300"
          >
            {/* Image Banner */}
            {proj.image_url && (
              <div className="h-48 w-full overflow-hidden">
                <img
                  src={proj.image_url}
                  alt={proj.title}
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            )}

            {/* Content */}
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {proj.title}
              </h3>
              <p className="text-gray-600 text-sm mb-4">{proj.description}</p>

              {/* Technologies */}
              <div className="flex flex-wrap gap-2 mb-4">
                {proj.technologies.map((tech, j) => (
                  <span
                    key={j}
                    className="text-xs bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full"
                  >
                    {tech}
                  </span>
                ))}
              </div>

              {/* CTA Button */}
              <a
                href={proj.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-indigo-600 font-medium group-hover:underline"
              >
                Learn More
                <span className="ml-2 w-8 h-8 flex items-center justify-center bg-indigo-600 text-white rounded-full group-hover:bg-indigo-700 transition duration-300">
                  →
                </span>
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
